import { jsxs as r, Fragment as g, jsx as o } from "react/jsx-runtime";
import { getRatingImage as h } from "./utils.js";
import A from "@material-ui/core/Box";
import "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardActionArea";
import "@material-ui/core/CardActions";
import "@material-ui/core/CardContent";
import "@material-ui/core/CardMedia";
import "@material-ui/core/Checkbox";
import "@material-ui/core/Chip";
import "@material-ui/core/Container";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/ExpansionPanel";
import "@material-ui/core/ExpansionPanelDetails";
import "@material-ui/core/ExpansionPanelSummary";
import "@material-ui/core/FormControlLabel";
import p from "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/InputLabel";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemText";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Paper";
import "@material-ui/core/ScopedCssBaseline";
import "@material-ui/core/Select";
import "@material-ui/core/styles/createStyles";
import f from "@material-ui/core/styles/makeStyles";
import S from "@material-ui/core/styles/useTheme";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/Tooltip";
import I from "@material-ui/core/Typography";
import d from "@material-ui/core/useMediaQuery";
import "@material-ui/core/withWidth";
import "@material-ui/icons/Bathtub";
import "@material-ui/icons/CalendarToday";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Close";
import "@material-ui/icons/ExpandMore";
import "@material-ui/icons/Hotel";
import "@material-ui/icons/KeyboardArrowDown";
import "@material-ui/icons/Pets";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Search";
import "@material-ui/lab/Alert";
import "@propify-tenant-client/common";
const x = "data:image/png;base64,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", b = f((e) => ({
  container: {
    fontFamily: e.typography.fontFamily,
    padding: 20,
    border: "1px solid rgba(0, 0, 0, 0.10)",
    borderRadius: 6
  },
  schoolContainer: {
    display: "flex",
    gap: "12px",
    margin: 12,
    paddingBottom: 14,
    cursor: "pointer"
  },
  schoolInfo: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 12,
    paddingRight: 8
  },
  ratingCircle: {
    height: 40,
    width: 40,
    borderRadius: "50%",
    backgroundColor: "#029468",
    border: "2px solid #B2DFCE",
    color: "white",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  ratingMax: {
    fontSize: 10
  },
  schoolName: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: "140%",
    height: 44,
    lineClamp: 2,
    overflow: "hidden",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    textOverflow: "ellipsis"
  },
  communityRatingLabel: {
    fontSize: 13,
    fontWeight: 500
  },
  communityRating: {
    position: "relative",
    left: -7,
    fontSize: 22,
    marginTop: -5,
    marginBottom: -3
  },
  distance: {
    fontSize: 11,
    fontWeight: 600
  },
  greatSchoolLink: {
    color: "black"
  }
})), xo = ({ schools: e = [] }) => {
  const t = b(), n = S(), s = d(n.breakpoints.down("sm")), c = d(n.breakpoints.down("xs"));
  return /* @__PURE__ */ r(g, { children: [
    /* @__PURE__ */ o(p, { container: !0, className: t.container, children: e.map((i, l) => {
      let m, a;
      return c ? (a = l + 1 !== e.length ? "1px solid rgba(0, 0, 0, 0.10)" : void 0, m = void 0) : s ? (m = (l + 1) % 2 !== 0 ? "1px solid rgba(0, 0, 0, 0.10)" : void 0, a = void 0) : (m = (l + 1) % 3 !== 0 ? "1px solid rgba(0, 0, 0, 0.10)" : void 0, a = void 0), /* @__PURE__ */ o(p, { item: !0, xs: 12, sm: 6, md: 4, children: /* @__PURE__ */ r(
        "div",
        {
          className: t.schoolContainer,
          style: {
            borderRight: m,
            borderBottom: a
          },
          onClick: () => {
            window.open(i["overview-url"], "_blank");
          },
          children: [
            /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o("img", { src: h(i.rating) }) }),
            /* @__PURE__ */ r("div", { className: t.schoolInfo, children: [
              /* @__PURE__ */ o("div", { className: t.schoolName, "data-school-name": i.name, children: i.name }),
              /* @__PURE__ */ r("span", { className: t.distance, children: [
                i.distance.toFixed(2),
                " mi"
              ] })
            ] })
          ]
        }
      ) }, i.name);
    }) }),
    /* @__PURE__ */ r(A, { my: 2, display: "flex", alignItems: "center", justifyContent: "flex-end", style: { gap: 12 }, children: [
      /* @__PURE__ */ r(I, { style: { fontSize: 13 }, "data-testid": "about-greatschools", children: [
        "Data provided by",
        " ",
        /* @__PURE__ */ o(
          "a",
          {
            className: t.greatSchoolLink,
            href: "https://www.greatschools.org/",
            target: "_blank",
            rel: "nofollow",
            children: /* @__PURE__ */ o("strong", { children: "GreatSchools.org" })
          }
        ),
        " ",
        "© ",
        (/* @__PURE__ */ new Date()).getFullYear(),
        ". All rights reserved."
      ] }),
      /* @__PURE__ */ o("a", { href: "https://www.greatschools.org/", target: "_blank", rel: "nofollow", children: /* @__PURE__ */ o("img", { src: x, alt: "GreatSchools.org" }) })
    ] })
  ] });
};
export {
  xo as default
};
//# sourceMappingURL=GreatSchools.js.map
